import { FC, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Divider,
  Card,
  TableCell,
  TableRow,
  TableContainer,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Box
} from '@mui/material';

import { useModalStore } from '../../../zustandStore/store.attributes';
import { HttpModal } from '../../../components/HttpModal/HttpModal';
import { API } from '../../../config/config';
import { DynamicTable } from '../../../components/DynamicTable/DynamicTable';
import { useAuth } from 'src/hooks/useAuth';

interface PermissionsProps {
  className?: string;
  currentStaff?: any;
  setCurrentStaff?: React.Dispatch<React.SetStateAction<any>>;
}

const PermissionsContent: FC<PermissionsProps> = ({
                                                    currentStaff,
                                                    setCurrentStaff
                                                  }) => {
  const { enhancedFetch } = useAuth();
  const [permission, setPermission] = useState('');
  const [permissions, setPermissions] = useState<any[]>([]);

  const state = useModalStore((state) => state);
  const action = state.actions;

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await enhancedFetch(`${API.HOST}/api/v1/permissions`, {
          method: 'GET'
        });
        setPermissions(
          response.map((attribute: any) => ({
            id: attribute.id,
            permissionName: attribute.permissionName
          }))
        );
      } catch (error) {
        console.error('Failed to fetch permissions:', error);
      }
    };

    fetchPermissions();
  }, []);

  const handlePermissionChange = async (permName: string, checked: boolean) => {
    if (!currentStaff || !setCurrentStaff) return;

    const newPermissions = checked
      ? [...(currentStaff.permissions || []), permName]
      : (currentStaff.permissions || []).filter((p) => p !== permName);

    setCurrentStaff((prevStaff) => ({
      ...prevStaff!,
      permissions: newPermissions
    }));
  };

  return (
    <Card>
      <HttpModal
        onClose={() => {
          action.setModal({ modalOpen: false });
        }}
        additionalPayload={{}}
        onErrorCallback={(error) => {
          console.error('HttpModal error:', error);
        }}
        onSubmitCallback={(response) => {
          action.setModal({ modalOpen: false });
        }}
        openModal={state.settings.modalOpen}
        fields={[
          {
            type: 'text',
            label: 'Permission',
            placeholder: 'Permission',
            name: 'permission',
            required: true,
            disabled: false,
            value: permission,
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
              setPermission(e.target.value);
            }
          }
        ]}
        baseUrl={`${API.HOST}/api/v1/permissions`}
        method={'POST'}
        headers={{ 'Content-Type': 'application/json' }}
        title={'Add Permission'}
      />

      <Divider />

      <TableContainer>
        <DynamicTable
          rows={permissions.map((perm) => ({
            id: perm.id,
            permissionName: perm.permissionName,
            actions: perm
          }))}
          headers={[

            { headerName: 'Permission Name', field: 'permissionName' },
            {
              headerName: 'Actions', field: 'actions', renderCell: ({ row: perm }) => {
                return (
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            currentStaff?.permissions?.includes(
                              perm.permissionName
                            ) || false
                          }
                          onChange={(e) =>
                            handlePermissionChange(
                              perm.permissionName,
                              e.target.checked
                            )
                          }
                          disabled={!currentStaff || !setCurrentStaff}
                          sx={{ padding: 0, margin: 0, display: '' }}
                        />
                      }
                      label={<Box />}
                    />
                  </FormGroup>
                );
              }
            }
          ]}
        />
      </TableContainer>
    </Card>
  );
};

PermissionsContent.propTypes = {
  className: PropTypes.string
};

export default PermissionsContent;
